<!-- display-mobile-22 preview — a native in-article unit whose headline spans
     the whole slot, with the square creative below it on the left and a copy
     column carrying the description and a row that pairs the disclosure chip and
     the advertiser with an outlined action button. Placement 4 draws the same
     unit at the head of the page; placement 21 is the same one mid-article with
     the headline tucked into the copy column instead. -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in, ending on a paragraph's short line -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <i class="bi bi-info-circle da-adchoices"></i>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-ad-row d-flex flex-row">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
          <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="da-creative-image creative-missing" [title]="missingDimensionLabel">{{ missingDimensionShortLabel }}</div>
        </a>

        <div class="da-copy">
          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <div class="da-footer d-flex flex-row align-items-center">
            <!-- The mock is a Croatian preview, so Google's own label reads
                 "Oglas" there; it stays English here like the other placements,
                 since the network localises it at serve time. -->
            <span class="da-badge">Ad</span>

            <!-- GenSingleImagePreviewData carries no advertiser field, so the name
                 is a literal here, the same compromise the other placements make. -->
            <span class="da-advertiser">Valamar</span>

            <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta ms-auto">
              {{ data.ctaText || "Your call to action" }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad, to the bottom of the screen -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
